import { useState } from "react";
import { ArrowRight } from "lucide-react";
import LeadCaptureModal from "../shared/LeadCaptureModal";

export default function CTABanner() {
  const [open, setOpen] = useState(false);
  return (
    <section
      id="audit"
      className="relative py-20 md:py-28 bg-charcoal text-white overflow-hidden"
      data-testid="cta-banner-section"
    >
      <div className="absolute inset-0 bg-grid-pattern-dark opacity-50 pointer-events-none" />
      <div
        className="absolute -right-32 -top-32 w-[480px] h-[480px] rounded-full bg-electric/20 blur-3xl pointer-events-none"
        aria-hidden
      />
      <div className="container relative grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7">
          <p className="text-overline text-electric mb-4">
            10 — Free Marketing Audit
          </p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-extrabold leading-[1.05] text-balance">
            Ready to Turn Your Marketing into a Revenue Engine?
          </h2>
          <p className="mt-5 text-lg text-zinc-300 max-w-xl">
            Drop your details. We'll send back a free, no-obligation marketing
            audit covering SEO, paid ads, social, and AI visibility gaps —
            delivered within 24 hours.
          </p>
        </div>

        <div className="lg:col-span-5">
          <div
            className="bg-white text-charcoal p-7 md:p-9 rounded-2xl border border-zinc-100 shadow-2xl shadow-charcoal/10"
            data-testid="audit-form"
          >
            <p className="text-overline text-electric mb-3">
              Free Audit · Email + WhatsApp
            </p>
            <h3 className="font-display text-2xl md:text-3xl font-extrabold text-charcoal leading-tight">
              Get your free marketing audit in 24 hours.
            </h3>
            <p className="mt-3 text-sm text-zinc-600 leading-relaxed">
              Our senior strategist personally reviews your digital presence and
              sends you a fully written audit + a 15-minute Loom walkthrough.
            </p>
            <button
              type="button"
              onClick={() => setOpen(true)}
              data-testid="audit-open-modal"
              aria-label="Get my free marketing audit"
              className="mt-6 w-full inline-flex items-center justify-center gap-2 bg-electric text-white px-6 py-3.5 font-semibold rounded-xl hover:bg-electric-500 transition-all shadow-lg shadow-electric/30"
            >
              Get My Free Audit <ArrowRight className="w-4 h-4" />
            </button>
            <p className="mt-3 text-xs text-zinc-500 text-center">
              No spam. We reply within 24h. By submitting you agree to
              Lumotis's privacy policy.
            </p>
          </div>
        </div>
      </div>

      <LeadCaptureModal
        open={open}
        onClose={() => setOpen(false)}
        eyebrow="Free ASO Audit"
        title="Where should we send your audit?"
        description="Hand-written by a senior strategist. Delivered to your email + WhatsApp within 24 hours."
        ctaLabel="Send my free audit"
        successTitle="Audit booked!"
        successBody="Our senior strategist will email + WhatsApp you the 12-page audit within 24 hours."
        source="cta-banner-audit"
      />
    </section>
  );
}
